// src/pages/ClasesPruebaPage.js
import React, { useState, useEffect } from 'react';

const bs = { fontFamily: "'Montserrat', sans-serif" };
const ds = { fontFamily: "'Cormorant Garamond', Georgia, serif" };

const STATUS_COLORS = {
  pendiente:  { bg: '#fef3c7', color: '#d97706', label: 'Pendiente'  },
  confirmada: { bg: '#dcfce7', color: '#16a34a', label: 'Confirmada' },
  cancelada:  { bg: '#fee2e2', color: '#dc2626', label: 'Cancelada'  },
};

const ClasesPruebaPage = () => {
  const [solicitudes, setSolicitudes] = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [filter,      setFilter]      = useState('todas');
  const [updating,    setUpdating]    = useState(null);

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const res  = await fetch('/api/list_clases_prueba.php', { credentials: 'include' });
      const json = await res.json();
      if (json.success) setSolicitudes(json.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const updateStatus = async (id, status) => {
    setUpdating(id);
    try {
      const res  = await fetch('/api/update_clase_prueba.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ id, status }),
      });
      const json = await res.json();
      if (json.success) {
        setSolicitudes(prev => prev.map(s => s.id === id ? { ...s, status } : s));
      }
    } catch (e) { console.error(e); }
    finally { setUpdating(null); }
  };

  const filtered = filter === 'todas'
    ? solicitudes
    : solicitudes.filter(s => s.status === filter);

  const counts = {
    todas:      solicitudes.length,
    pendiente:  solicitudes.filter(s => s.status === 'pendiente').length,
    confirmada: solicitudes.filter(s => s.status === 'confirmada').length,
    cancelada:  solicitudes.filter(s => s.status === 'cancelada').length,
  };

  const formatDate = (str) => {
    if (!str) return '—';
    return new Date(str).toLocaleDateString('es-MX', {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };

  const formatBirth = (str) => {
    if (!str) return '—';
    const d = new Date(str + 'T12:00:00');
    const age = Math.floor((new Date() - d) / (365.25 * 24 * 3600 * 1000));
    return `${d.toLocaleDateString('es-MX', { year: 'numeric', month: 'short', day: 'numeric' })} (${age} años)`;
  };

  return (
    <div style={{ padding: '24px 16px', maxWidth: '1100px', margin: '0 auto' }}>

      {/* Header */}
      <div style={{ marginBottom: '24px' }}>
        <h1 style={{ ...ds, fontSize: '2rem', fontWeight: 400, color: '#060D14', margin: '0 0 4px' }}>
          Clases de Prueba
        </h1>
        <p style={{ ...bs, fontSize: '12px', color: '#bbb', margin: 0 }}>
          {counts.pendiente} pendiente{counts.pendiente !== 1 ? 's' : ''} · {counts.confirmada} confirmada{counts.confirmada !== 1 ? 's' : ''}
        </p>
      </div>

      {/* Filtros por status */}
      <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', flexWrap: 'wrap' }}>
        {[
          { key: 'todas',      label: 'Todas'      },
          { key: 'pendiente',  label: 'Pendientes' },
          { key: 'confirmada', label: 'Confirmadas'},
          { key: 'cancelada',  label: 'Canceladas' },
        ].map(({ key, label }) => (
          <button key={key} onClick={() => setFilter(key)} style={{
            ...bs, background: filter === key ? '#961914' : 'white',
            color: filter === key ? 'white' : '#666',
            border: `1px solid ${filter === key ? '#961914' : '#e5e0e0'}`,
            padding: '7px 16px', cursor: 'pointer', fontSize: '11px',
            fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase',
            borderRadius: '2px', transition: 'all 0.2s',
          }}>
            {label}
            <span style={{ marginLeft: '6px', opacity: 0.7 }}>({counts[key]})</span>
          </button>
        ))}
      </div>

      {/* Lista */}
      {loading ? (
        <div style={{ padding: '48px', textAlign: 'center' }}>
          <p style={{ ...bs, fontSize: '12px', color: '#bbb' }}>Cargando solicitudes…</p>
        </div>
      ) : filtered.length === 0 ? (
        <div style={{ background: 'white', border: '1px solid #f0eaea',
          padding: '64px', textAlign: 'center', borderRadius: '2px' }}>
          <p style={{ ...bs, fontSize: '12px', color: '#bbb' }}>
            No hay solicitudes {filter !== 'todas' ? `con estado "${filter}"` : ''}.
          </p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {filtered.map(s => {
            const st = STATUS_COLORS[s.status] || STATUS_COLORS.pendiente;
            return (
              <div key={s.id} style={{ background: 'white', border: '1px solid #f0eaea',
                borderRadius: '2px', overflow: 'hidden' }}>

                {/* Header tarjeta */}
                <div style={{ display: 'flex', justifyContent: 'space-between',
                  alignItems: 'center', padding: '14px 20px',
                  background: '#fdfafa', borderBottom: '1px solid #f5f0f0',
                  flexWrap: 'wrap', gap: '10px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span style={{ ...bs, fontSize: '10px', color: '#bbb',
                      letterSpacing: '0.15em' }}>#{s.id}</span>
                    <h3 style={{ ...ds, fontSize: '1.1rem', fontWeight: 600,
                      color: '#060D14', margin: 0 }}>
                      {s.nombre_completo}
                    </h3>
                    {/* Badge status */}
                    <span style={{ ...bs, fontSize: '10px', fontWeight: 600,
                      letterSpacing: '0.12em', textTransform: 'uppercase',
                      background: st.bg, color: st.color,
                      padding: '3px 10px', borderRadius: '20px' }}>
                      {st.label}
                    </span>
                  </div>
                  <span style={{ ...bs, fontSize: '11px', color: '#bbb' }}>
                    {formatDate(s.fecha_solicitud)}
                  </span>
                </div>

                {/* Detalle */}
                <div style={{ padding: '16px 20px', display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>

                  {/* Info persona */}
                  <div>
                    <p style={{ ...bs, fontSize: '10px', letterSpacing: '0.15em',
                      textTransform: 'uppercase', color: '#bbb', marginBottom: '8px' }}>
                      Datos personales
                    </p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <p style={{ ...bs, fontSize: '12px', color: '#060D14', margin: 0 }}>
                        <span style={{ color: '#aaa' }}>Nacimiento:</span> {formatBirth(s.fecha_nacimiento)}
                      </p>
                      <p style={{ ...bs, fontSize: '12px', color: '#060D14', margin: 0 }}>
                        <span style={{ color: '#aaa' }}>Contacto:</span> {s.contacto}
                      </p>
                    </div>
                  </div>

                  {/* Info clase */}
                  <div>
                    <p style={{ ...bs, fontSize: '10px', letterSpacing: '0.15em',
                      textTransform: 'uppercase', color: '#bbb', marginBottom: '8px' }}>
                      Clase solicitada
                    </p>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      {s.horario.disciplina && (
                        <p style={{ ...ds, fontSize: '1rem', fontWeight: 600,
                          color: '#961914', margin: 0 }}>
                          {s.horario.disciplina}
                        </p>
                      )}
                      <p style={{ ...bs, fontSize: '12px', color: '#666', margin: 0 }}>
                        {s.horario.dia_semana && `${s.horario.dia_semana} `}
                        {s.horario.hora_inicio && `${s.horario.hora_inicio}`}
                        {s.horario.hora_fin && ` – ${s.horario.hora_fin}`}
                        {!s.horario.dia_semana && s.horario.texto}
                      </p>
                      {s.horario.nivel && (
                        <p style={{ ...bs, fontSize: '11px', color: '#aaa', margin: 0 }}>
                          {s.horario.nivel}
                        </p>
                      )}
                      {s.horario.maestro && (
                        <p style={{ ...bs, fontSize: '11px', color: '#aaa', margin: 0 }}>
                          {s.horario.maestro}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Acciones */}
                  <div>
                    <p style={{ ...bs, fontSize: '10px', letterSpacing: '0.15em',
                      textTransform: 'uppercase', color: '#bbb', marginBottom: '8px' }}>
                      Actualizar status
                    </p>
                    <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
                      {['pendiente','confirmada','cancelada'].map(st_key => (
                        <button key={st_key}
                          disabled={s.status === st_key || updating === s.id}
                          onClick={() => updateStatus(s.id, st_key)}
                          style={{ ...bs, padding: '6px 12px', cursor: s.status === st_key ? 'default' : 'pointer',
                            fontSize: '10px', fontWeight: 600, letterSpacing: '0.1em',
                            textTransform: 'uppercase', borderRadius: '2px', transition: 'all 0.2s',
                            background: s.status === st_key ? STATUS_COLORS[st_key].bg : 'none',
                            color: s.status === st_key ? STATUS_COLORS[st_key].color : '#aaa',
                            border: `1px solid ${s.status === st_key ? 'transparent' : '#e5e0e0'}`,
                            opacity: updating === s.id ? 0.5 : 1,
                          }}>
                          {STATUS_COLORS[st_key].label}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ClasesPruebaPage;
